import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Container, Row, Col, Card, Form, Button, Modal } from 'react-bootstrap';

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000";

const BecomeATasker = () => {
    const [cities, setCities] = useState([]);
    const [notArcaRegistered, setNotArcaRegistered] = useState(false);
    const [noInsurance, setNoInsurance] = useState(false);
    const [termsAccepted, setTermsAccepted] = useState(false);
    const [showTermsModal, setShowTermsModal] = useState(false);
    const [hasReadTerms, setHasReadTerms] = useState(false);

    const termsContent = `TÉRMINOS Y CONDICIONES DE USO DE LOCALHIRE

TÉRMINOS Y CONDICIONES – LOCAL HIRE (MODELO ARGENTINA)
Última actualización: [dd/mm/aaaa]
Estos Términos y Condiciones (los “Términos”) regulan el acceso y uso de la plataforma digital Local Hire (la “Plataforma”), incluyendo su aplicación móvil y/o sitio web (la “App” y/o el “Sitio”), provista por Leonardo Rolón, CUIT 20-30621265-7, con domicilio en Amenabar 1365 de la ciudad de Reconquista, Santa Fe (en adelante, “Local Hire”, “nosotros”, “nuestro”).
Al registrarse, acceder o utilizar la Plataforma, usted (el “Usuario”) acepta estos Términos de forma expresa, obligatoria y vinculante. Si no está de acuerdo, debe abstenerse de usar la Plataforma.
Contacto: administracion@localhire.com.ar | Amenabar 1365, Reconquista, Santa Fe.

1) Definiciones
•	“Usuario”: persona humana o jurídica que utiliza la Plataforma para solicitar, contratar o administrar servicios.
•	“Prestador”: persona humana o jurídica que ofrece y presta servicios (p. ej., plomería, electricidad, jardinería, limpieza, mudanzas, etc.) a través de la Plataforma, actuando por cuenta propia.
•	“Servicio”: trabajo o prestación ofrecida y ejecutada por un Prestador.
•	“Solicitud”: requerimiento de un Usuario para contratar un Servicio.
•	“Orden”: Solicitud aceptada y confirmada por el Prestador y, en su caso, pagada o garantizada conforme la modalidad vigente.
•	“Tarifa del Servicio de Plataforma”: cargo que Local Hire puede cobrar por el uso de la Plataforma (al Usuario y/o al Prestador), si corresponde.
•	“Contenido”: textos, imágenes, reseñas, calificaciones, mensajes, documentación, etc., cargados por Usuarios/Prestadores.
•	“Procesadores de Pago”: terceros que procesan cobros/pagos (pasarelas, adquirentes, billeteras), si se habilitan.

2) Objeto y rol de Local Hire (intermediación)
Local Hire ofrece una plataforma de intermediación que facilita el contacto entre Usuarios que solicitan servicios y Prestadores que los ofrecen. Local Hire no presta por sí misma los Servicios, no emplea a los Prestadores, no garantiza la calidad/resultado del Servicio y no es parte del contrato principal que se celebra entre Usuario y Prestador, salvo que se indique expresamente lo contrario en una modalidad específica (por ejemplo, “Servicio garantizado por Local Hire”, si existiera). Este esquema es consistente con el modelo de marketplace utilizado por plataformas similares.

3) Capacidad. Registro de personas jurídicas
La Plataforma está disponible únicamente para personas con capacidad legal para contratar. Si se registra una persona jurídica, quien la registre declara contar con facultades suficientes para obligarla.

4) Creación de cuenta. Seguridad
4.1. Para usar funcionalidades completas, el Usuario debe crear una cuenta (“Cuenta”), proporcionando datos veraces y actualizados (nombre, teléfono, correo, dirección/ubicación, etc.).
4.2. La Cuenta es personal e intransferible. Está prohibido crear cuentas múltiples para fines fraudulentos o eludir sanciones.
4.3. El Usuario es responsable por el resguardo de credenciales y toda actividad en su Cuenta. Debe notificar de inmediato cualquier uso no autorizado.
Local Hire podrá solicitar información adicional para verificar identidad y suspender o cancelar cuentas ante inconsistencias o sospecha de fraude.

5) Reglas de uso. Conductas prohibidas
Se prohíbe (i) usar la Plataforma con fines ilícitos; (ii) suplantación de identidad; (iii) publicar información falsa/engañosa; (iv) acosar, discriminar o amenazar; (v) cargar malware o intentar vulnerar la seguridad; (vi) extraer datos masivamente (scraping); (vii) usar la Plataforma para esquemas piramidales o reventa no autorizada.
Local Hire puede adoptar medidas de moderación (remoción de Contenido, suspensión, cancelación).

6) Funcionamiento de la contratación (flujo básico)
6.1. El Usuario ingresa una Solicitud, describiendo el Servicio, ubicación, fecha/hora preferida, fotos o información relevante.
6.2. La Plataforma puede mostrar Prestadores disponibles, perfiles, reputación, estimaciones, y/o permitir que Prestadores envíen presupuestos.
6.3. La Orden se considera confirmada cuando el Prestador acepta la Solicitud y el Usuario confirma (y, si aplica, realiza pago/garantía).
6.4. El Usuario es responsable por la exactitud del domicilio, acceso, condiciones del lugar y detalles técnicos informados.

7) Precios, presupuestos y cargos
7.1. Precio del Servicio: lo fija el Prestador (presupuesto, tarifa por hora, tarifa fija, materiales, etc.).
7.2. Materiales y adicionales: el Prestador debe informar por anticipado, en la medida de lo posible, costos de repuestos/materiales y/o trabajos no previstos.
7.3. Tarifa de Plataforma: Local Hire podrá cobrar una Tarifa al Usuario y/o al Prestador (comisión, cargo fijo, cargo por alta demanda, etc.), la cual se informará antes de confirmar la Orden.

8) Pagos, retenciones y reembolsos (si se habilitan pagos in-app)
8.1. La Plataforma puede permitir (a) pago directo al Prestador por fuera de la app; o (b) pago electrónico dentro de la app a través de Procesadores de Pago.
8.2. Si se habilitan pagos en app, el Usuario autoriza el débito/cargo del medio de pago elegido al confirmar la Orden. Los tiempos de reintegro dependen del emisor/procesador.
8.3. Local Hire puede implementar retenciones/escrow hasta la finalización del Servicio, o liberación parcial, según la modalidad comunicada.
8.4. Si procede un reembolso, Local Hire lo tramitará por el mismo medio de pago cuando sea posible; si no, podrá acreditarse saldo a favor/cupón, informándolo al Usuario.

9) Cancelaciones, reprogramaciones y “no show”
9.1. El Usuario puede cancelar o reprogramar según el estado de la Orden y las ventanas informadas en la app.
9.2. Puede aplicarse cargo por cancelación tardía o por “no show” (ausencia del Usuario o imposibilidad de acceso al domicilio) si el Prestador ya se desplazó o reservó agenda.
9.3. El Prestador puede cancelar ante causas justificadas (imposibilidad técnica, riesgo, falta de acceso, condiciones inseguras, etc.). En ese caso, se informará y, si hubiera pago, se gestionará reembolso conforme corresponda.

10) Calidad, garantías y reclamos
10.1. El Prestador es el responsable directo por la calidad, idoneidad, seguridad, permisos, habilitaciones, cumplimiento normativo y resultado del Servicio.
10.2. Local Hire puede ofrecer canales de atención y gestión de reclamos, pero ello no implica asumir responsabilidad por el Servicio. Este enfoque es consistente con términos de marketplaces.
10.3. Si Local Hire implementa programas de “garantía” o “protección”, sus condiciones se publicarán como anexos/políticas especiales.

11) Seguridad, verificación y antecedentes
Local Hire puede, sin obligación, implementar verificaciones de identidad, documentación o controles de calidad. El Usuario comprende que dichas verificaciones no garantizan ausencia de riesgos. Se recomienda adoptar medidas razonables de seguridad (verificar identidad, no compartir datos sensibles, etc.).

12) Sistema de reputación, comentarios y contenido
12.1. Usuarios y Prestadores pueden dejar calificaciones y comentarios.
12.2. Se prohíben contenidos ofensivos, discriminatorios, falsos, difamatorios o de competencia desleal.
12.3. Local Hire puede moderar, ocultar o eliminar comentarios y contenido, y conservar evidencia ante investigaciones.

13) Propiedad intelectual
La Plataforma, marcas, logos, software, diseños y contenidos propios de Local Hire están protegidos por normativa aplicable. El Usuario recibe una licencia no exclusiva, revocable, intransferible para usar la Plataforma conforme estos Términos.

14) Datos personales y privacidad (Argentina)
Local Hire trata datos personales conforme la normativa aplicable y su Política de Privacidad. En Argentina, la Ley 25.326 protege los datos personales y reconoce derechos de acceso, rectificación y supresión, entre otros.
Local Hire podrá compartir datos mínimos necesarios entre Usuario y Prestador para ejecutar la Orden (por ejemplo, nombre, teléfono, dirección/ubicación, detalles del trabajo), y con Procesadores de Pago cuando corresponda.

15) Servicios de terceros
La Plataforma puede integrar servicios de terceros (mapas, mensajería, pagos, analítica, publicidad). Es posible que apliquen términos de terceros. Local Hire no controla dichos servicios. En términos similares, otras plataformas también contemplan esta regla.

16) Limitación de responsabilidad
En la máxima medida permitida por la ley, Local Hire no será responsable por:
(a) daños derivados de la ejecución o no ejecución del Servicio por el Prestador;
(b) pérdidas indirectas, lucro cesante, daños punitivos (salvo norma imperativa);
(c) demoras por tráfico, clima, terceros, fuerza mayor;
(d) daños causados por información falsa del Usuario o Prestador.
Nada de lo aquí dispuesto excluye responsabilidades que no puedan excluirse por ley (por ejemplo, normas de defensa del consumidor cuando resulten aplicables).

17) Relación entre Local Hire y Prestadores (independencia)
Los Prestadores actúan como independientes: no existe relación laboral, societaria, mandato o representación con Local Hire. El Prestador es responsable por sus obligaciones fiscales, previsionales, seguros, habilitaciones y cumplimiento normativo.

18) Indemnidad
Usuario y Prestador se obligan a mantener indemne a Local Hire frente a reclamos de terceros derivados de: incumplimientos, servicios defectuosos, infracciones legales, violaciones de derechos de terceros o uso indebido de la Plataforma.

19) Suspensión, baja y terminación
Local Hire podrá suspender o cancelar cuentas u operaciones ante: fraude, riesgos de seguridad, conductas prohibidas, incumplimientos reiterados o requerimientos de autoridad.
El Usuario puede solicitar baja de Cuenta mediante la app o el canal informado.

20) Modificaciones de los Términos
Local Hire puede actualizar estos Términos. Cuando sea exigible o razonable, se solicitará aceptación para continuar usando la Plataforma. Local Hire contempla actualizaciones/consentimiento en su esquema de T&C.

21) Ley aplicable y jurisdicción
Estos Términos se rigen por las leyes de la República Argentina. Para controversias, serán competentes los tribunales ordinarios de Reconquista, Santa Fe, salvo norma imperativa aplicable.

`;

    const handleTermsScroll = (e) => {
        const { scrollTop, scrollHeight, clientHeight } = e.target;
        if (scrollTop + clientHeight >= scrollHeight - 10) {
            setHasReadTerms(true);
        }
    };

    useEffect(() => {
        const fetchCities = async () => {
            try {
                const response = await fetch(`${API_URL}/api/cities`);
                const data = await response.json();
                setCities(data);
            } catch (error) {
                console.error('Error fetching cities:', error);
            }
        };

        fetchCities();
    }, []);

    const handleSubmit = async (event) => {
        if (!termsAccepted) {
            alert("Por favor, acepta los términos y condiciones para continuar.");
            return;
        }

        event.preventDefault();
        const formData = new FormData(event.target);

        const customService = formData.get('customService');
        if (customService) {
            formData.append('services', customService);
        }

        try {
            const response = await fetch(`${API_URL}/api/taskers`, {
                method: 'POST',
                body: formData
            });

            if (response.ok) {
                alert("¡Solicitud enviada con éxito! Bienvenido a la comunidad.");
                event.target.reset();
            } else {
                alert("Hubo un error al enviar la solicitud.");
            }
        } catch (error) {
            console.error("Error:", error);
            alert("Error de conexión.");
        }
    };

    // Categorías estáticas para el formulario
    const serviceCategories = {
        "Hogar": ["Mantenimiento", "Limpieza", "Cocina"],
        "Reparaciones": ["Electricidad", "Plomería", "Gas", "Electrodomésticos"],
        "Exteriores": ["Jardinería", "Piscinas", "Control de Plagas"]
    };

    return (
        <Container className="my-5 local-hire-design">
            <Row className="text-center mb-5">
                <Col>
                    <h1 className="title text-primary fw-bold">Unite a nuestra comunidad</h1>
                    <p className="lead text-secondary">Que todos te conozcan por tus servicios.</p>
                </Col>
            </Row>
            <Row className="mb-5">
                <Col className="text-center text-primary">
                    <h2>Beneficios de Unirte a la comunidad</h2>
                </Col>
            </Row>
            <Row className="mb-5">
                {["Flexibilidad", "Ganancias competitivas", "Apoyo de la comunidad"].map((title, index) => (
                    <Col md={4} key={index}>
                        <Card className="h-100 text-center shadow-sm rounded-lg">
                            <Card.Body>
                                <Card.Title className="fw-bold text-primary">{title}</Card.Title>
                                <Card.Text className="text-muted">{index === 0 ? "Decide cuándo y cuánto trabajar." : index === 1 ? "Gana dinero según tus habilidades y experiencia." : "Acceso a una red de servicios y soporte profesional."}</Card.Text>
                            </Card.Body>
                        </Card>
                    </Col>
                ))}
            </Row>
            <Row className="mb-5">
                <Col md={{ span: 6, offset: 3 }}>
                    <h2 className="text-center mb-4 text-primary">Registrate para comenzar</h2>
                    <Form onSubmit={handleSubmit} className="shadow-sm p-4 rounded-lg">
                        <Form.Group className="mb-3">
                            <Form.Control type="text" name="name" placeholder="Nombre completo" required className="rounded-pill shadow-sm" />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Control type="email" name="email" placeholder="Correo electrónico" required className="rounded-pill shadow-sm" />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Control type="text" name="phone" placeholder="Teléfono" required className="rounded-pill shadow-sm" />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Select name="city" aria-label="Seleccionar localidad" className="rounded-pill shadow-sm" required>
                                <option value="">Selecciona tu localidad</option>
                                {cities.map(city => (
                                    <option key={city._id} value={city.city}>{city.city}</option>
                                ))}
                            </Form.Select>
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Foto de Perfil (Opcional)</Form.Label>
                            <Form.Control type="file" name="profile_image" accept="image/*" className="shadow-sm" />
                        </Form.Group>

                        <h4 className="mb-3 mt-4 text-primary text-center">Documentación Requerida</h4>
                        <Card className="shadow-sm p-4 mb-4 rounded-lg border-0 bg-light">
                            <Row>
                                <Col md={12} className="mb-3">
                                    <h5 className="fw-bold text-secondary">Documento Nacional de Identidad</h5>
                                    <p className="text-muted small">Sube fotos claras del frente y dorso de tu DNI.</p>
                                </Col>
                                <Col md={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Frente del DNI</Form.Label>
                                        <Form.Control type="file" name="dni_front" required accept="image/*,.pdf" />
                                    </Form.Group>
                                </Col>
                                <Col md={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Dorso del DNI</Form.Label>
                                        <Form.Control type="file" name="dni_back" required accept="image/*,.pdf" />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <hr className="my-3" />
                            <Row>
                                <Col md={12}>
                                    <h5 className="fw-bold text-secondary">Inscripción en ARCA</h5>
                                    <Form.Group className="mb-3">
                                        <Form.Check
                                            type="checkbox"
                                            id="notArcaRegistered"
                                            label="No estoy inscripto en ARCA"
                                            checked={notArcaRegistered}
                                            onChange={(e) => setNotArcaRegistered(e.target.checked)}
                                            name="not_arca_registered"
                                        />
                                    </Form.Group>
                                </Col>
                                {!notArcaRegistered && (
                                    <Col md={12}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Constancia de Inscripción / Monotributo</Form.Label>
                                            <Form.Control type="file" name="arca_file" required={!notArcaRegistered} accept=".pdf,image/*" />
                                        </Form.Group>
                                    </Col>
                                )}
                            </Row>
                            <hr className="my-3" />
                            <Row>
                                <Col md={12}>
                                    <h5 className="fw-bold text-secondary">Seguro</h5>
                                    <Form.Group className="mb-3">
                                        <Form.Check type="checkbox" id="noInsurance" label="No tengo seguro de accidentes personales" checked={noInsurance} onChange={(e) => setNoInsurance(e.target.checked)} name="no_insurance" />
                                    </Form.Group>
                                </Col>
                                {!noInsurance && (
                                    <Col md={12}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Póliza o Certificado de Cobertura</Form.Label>
                                            <Form.Control type="file" name="insurance_file" required={!noInsurance} accept=".pdf,image/*" />
                                        </Form.Group>
                                    </Col>
                                )}
                            </Row>
                        </Card>

                        <h3 className="text-center mb-3">Selecciona los servicios que prestas</h3>
                        <Row>
                            {Object.entries(serviceCategories).map(([category, services]) => (
                                <Col md={6} key={category} className="mb-3">
                                    <Card className="shadow-sm rounded-lg">
                                        <Card.Body>
                                            <Card.Title className="fw-bold text-primary">{category}</Card.Title>
                                            {services.map(service => (
                                                <Form.Check key={service} type="checkbox" label={service} name="services" value={service} className="text-muted" />
                                            ))}
                                        </Card.Body>
                                    </Card>
                                </Col>
                            ))}
                        </Row>
                        <Form.Group className="mb-3">
                            <div className="d-flex align-items-center flex-wrap">
                                <Form.Check
                                    type="checkbox"
                                    id="termsAndConditions"
                                    required
                                    checked={termsAccepted}
                                    onChange={(e) => setTermsAccepted(e.target.checked)}
                                    className="text-muted me-2"
                                    disabled={!hasReadTerms}
                                    label=""
                                />
                                <span className="text-muted">Acepto los&nbsp;</span>
                                <span className="text-primary text-decoration-underline" style={{ cursor: 'pointer' }} onClick={() => setShowTermsModal(true)}>términos y condiciones del servicio</span>
                            </div>
                            {!hasReadTerms && <Form.Text className="text-muted small">Debes leer todo el documento para poder aceptar.</Form.Text>}
                        </Form.Group>
                        <Button variant="primary" type="submit" className="w-100 rounded-pill shadow-sm" disabled={!termsAccepted}>Enviar solicitud</Button>
                    </Form>
                </Col>
            </Row>

            {/* Modal de Términos y Condiciones */}
            <Modal show={showTermsModal} onHide={() => setShowTermsModal(false)} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Términos y Condiciones</Modal.Title>
                </Modal.Header>
                <Modal.Body onScroll={handleTermsScroll} style={{ maxHeight: '400px', overflowY: 'auto', whiteSpace: 'pre-wrap' }}>
                    {termsContent}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowTermsModal(false)}>
                        Cerrar
                    </Button>
                    <Button variant="primary" disabled={!hasReadTerms} onClick={() => { setTermsAccepted(true); setShowTermsModal(false); }}>
                        He leído y acepto
                    </Button>
                </Modal.Footer>
            </Modal>
        </Container>
    );
};

export default BecomeATasker;